module.exports = __webpack_public_path__ + "img/arrow.70a7d261.svg";